module.exports = __webpack_public_path__ + "static/media/sell-banner-mobile.de95df05.png";